<template>
  <div class="row">
    <div class="col-lg-6">
      <div class="card">
        <div class="card-header">
          <div class="header-with-date">
            <h4>Dokumente von infrabau</h4>
            <div>
              <feather
                id="media_openCategoriesButton"
                type="grid"
                class="infra-blue pointer"
                @click="openCategoriesModal"
                style="margin-right:10px;"
              ></feather>
              <b-tooltip target="media_openCategoriesButton" triggers="hover" placement="left">Kategorien bearbeiten</b-tooltip>
              <feather id="media_openUploadButton" type="upload" class="infra-blue pointer" @click="openUploadModal"></feather>
              <b-tooltip target="media_openUploadButton" triggers="hover" placement="left">Dateien hinzufügen / hochladen</b-tooltip>
            </div>
          </div>
        </div>
        <div class="card-body">
          <!-- Start Table Downloads -->
          <div class="tbl-downloads">
            <div class="col-4 p-0">
              <div class="input-group" style="margin-top:20px;">
                <b-form-input style="border:1px solid lightgrey" v-model="tbl_filter.downloads" placeholder="Suchen"></b-form-input>
              </div>
            </div>

            <div class="table-responsive datatable-vue">
              <b-table
                show-empty
                :items="downloads"
                @filtered="onFilteredDownloads"
                :current-page="tbl_currentPage.downloads"
                :filter="tbl_filter.downloads"
                :per-page="tbl_perPage.downloads"
                :fields="tbl_fields.downloads"
              >
                <template slot="empty"><div class="text-center">Keine Downloads hinterlegt.</div></template>
                <template v-slot:cell(uploaded_by)="row">
                  {{ row.item.download_id.owner.first_name }} {{ row.item.download_id.owner.last_name }}
                </template>
                <template v-slot:cell(created_on)="row">
                  {{ transformDate(row.item.download_id.created_on) }}
                </template>
                <template v-slot:cell(aktionen)="row">
                    <feather
                      :id="'download_' + row.item.download_id.id"
                      type="download"
                      class="infra-blue pointer"
                      style="margin-right:5px;"
                      @click="downloadFile(row.item.download_id)"
                    ></feather>
                  <b-tooltip :target="'download_' + row.item.download_id.id" triggers="hover" placement="left">Download</b-tooltip>
                  <feather
                    :id="'remove_dd_' + row.item.download_id.id"
                    type="trash"
                    class="infra-blue pointer"
                    @click="removeDownloadAssignment(row.item.download_id)"
                  ></feather>
                  <b-tooltip :target="'remove_dd_' + row.item.download_id.id" placement="left">Zuordnung aufheben</b-tooltip>
                </template>
              </b-table>
              <div class="pagination-container" style="margin-top:10px;">
                <b-pagination
                  v-if="tbl_totalRows.downloads > tbl_perPage.downloads"
                  v-model="tbl_currentPage.downloads"
                  :total-rows="tbl_totalRows.downloads"
                  :per-page="tbl_perPage.downloads"
                  class="my-0"
                ></b-pagination>
              </div>
            </div>
            <div class="button-container">
              <b-button class="btn btn-primary" @click="openCategoriesModal" style="margin-right:10px;">Kategorien bearbeiten</b-button>
              <b-button class="btn btn-primary" @click="openUploadModal">Downloads bearbeiten</b-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-6">
      <div class="card">
        <div class="card-header">
          <div class="header-with-date">
            <h4>Kundenuploads</h4>
          </div>
        </div>
        <div class="card-body">
          <!--- table uploads start -->
          <div class="tbl-uploads">
            <div clas="row">
              <div class="col-4 p-0">
                <div class="input-group" style="margin-top:20px;">
                  <b-form-input style="border:1px solid lightgrey" v-model="tbl_filter.uploads" placeholder="Suchen"></b-form-input>
                </div>
              </div>
            </div>

            <div class="table-responsive datatable-vue">
              <b-table
                show-empty
                :items="uploads"
                @filtered="onFilteredUploads"
                :current-page="tbl_currentPage.uploads"
                :filter="tbl_filter.uploads"
                :per-page="tbl_perPage.uploads"
                :fields="tbl_fields.uploads"
              >
                <template slot="empty"><div class="text-center">Keine Downloads hinterlegt.</div></template>
                <template v-slot:cell(von)="row"> {{ row.item.owner.first_name }} {{ row.item.owner.last_name }} </template>
                <template v-slot:cell(created_on)="row">
                  {{ transformDate(row.item.created_on) }}
                </template>
                <template v-slot:cell(aktionen)="row">            
                    <feather
                      :id="'download_up_' + row.item.id"
                      type="download"
                      class="infra-blue pointer"
                      style="margin-right:5px;"
                      @click="downloadFile(row.item)"
                    ></feather>
                  <b-tooltip :target="'download_up_' + row.item.id" triggers="hover" placement="left">Download</b-tooltip>
                  <div v-if="isImage(row.item.file.type)" style="display:inline-block;">
                    <feather v-if="(row.item.file.type.indexOf('image') > -1)" type="eye" :id="'image_show_' + row.item.id" class="infra-blue pointer" @click="openImageModal(row.item.file)"></feather>
                    <b-tooltip :target="'image_show_' + row.item.id" triggers="hover" placement="left">Bild anzeigen</b-tooltip>
                  </div>
                </template>
              </b-table>
              <div class="pagination-container" style="margin-top:10px;">
                <b-pagination
                  v-if="tbl_totalRows.uploads > tbl_perPage.uploads"
                  v-model="tbl_currentPage.uploads"
                  :total-rows="tbl_totalRows.uploads"
                  :per-page="tbl_perPage.uploads"
                  class="my-0"
                ></b-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal id="addDownload" size="xl" ok-only @hide="resetUploadModal">
      <b-tabs v-model="active_tabs.downloads_all">
        <b-tab title="Downloads">
          <div clas="row">
            <div class="col-4">
              <div class="input-group" style="margin-top:20px;">
                <b-form-input style="border:1px solid lightgrey" v-model="tbl_filter.downloads_all" placeholder="Suchen"></b-form-input>
              </div>
            </div>
          </div>
          <div class="table-responsive datatable-vue">
            <b-table
              show-empty
              :items="downloads_all"
              @filtered="onFilteredDownloadsAll"
              :current-page="tbl_currentPage.downloads_all"
              :filter="tbl_filter.downloads_all"
              :per-page="tbl_perPage.downloads_all"
              :fields="tbl_fields.downloads_all"
            >
              <template slot="empty"><div class="text-center">Keine Downloads hinterlegt.</div></template>
              <template v-slot:cell(created_on)="row">
                {{ transformDate(row.item.created_on) }}
              </template>
              <template v-slot:cell(von)="row"> {{ row.item.owner.first_name }} {{ row.item.owner.last_name }} </template>
              <template v-slot:cell(actions)="row">
                <feather type="trash" class="infra-blue pointer" :id="'remove_dda_' + row.item.id" @click="deleteDownload(row.item.id)"></feather>
                <b-tooltip :target="'remove_dda_' + row.item.id" triggers="hover" placement="left">Download löschen</b-tooltip>
              </template>
            </b-table>
            <div class="pagination-container" style="margin-top:10px;">
              <b-pagination
                v-if="tbl_totalRows.downloads_all > tbl_perPage.downloads_all"
                v-model="tbl_currentPage.downloads_all"
                :total-rows="tbl_totalRows.downloads_all"
                :per-page="tbl_perPage.downloads_all"
                class="my-0"
              ></b-pagination>
            </div>
          </div>
        </b-tab>
        <b-tab title="Neuer Download">
          <div class="upload-container">
            <div class="form-error" v-if="hasError('newDownload-file')" style="padding:10px;text-align:center;">
              Bitte fügen Sie eine Datei zum Upload hinzu.
            </div>
            <div class="upload-dropzone" style="margin-bottom:10px;">
              <dropzone
                ref="download_dropzone"
                id="download_dropzone"
                class="dropzone-with-info"
                :options="this.dropzone_options.download"
                v-on:vdropzone-success="processNewDownloadFile"
                v-on:vdropzone-file-added="newDownload.file = true"
                v-on:vdropzone-removed-file="newDownload.file = false"
              ></dropzone>
            </div>

            <div class="upload_fields">
              <label>Name</label>
              <b-input-group class="form-input-group" prepend="Abc">
                <b-form-input
                  class="form-control"
                  name="newDownload-name"
                  v-model="newDownload.name"
                  v-bind:class="{ form_error: hasError('newDownload-name') }"
                ></b-form-input>
                <feather type="check" v-if="!hasError('newDownload-name')" class="checkmark"></feather>
                <feather type="x" v-if="hasError('newDownload-name')" class="failmark"></feather>
              </b-input-group>
              <label>Beschreibung</label>
              <b-input-group class="form-input-group">
                <textarea rows="3" class="form-control" name="newDownload-description" v-model="newDownload.description" />
              </b-input-group>
              <label>Kategorie</label>
              <b-input-group class="form-input-group">
                <b-form-select
                  v-model="newDownload.category"
                  :options="newDownload.category_options"
                  name="category"
                  v-bind:class="{ form_error: hasError('newDownload-category') }"
                ></b-form-select>
              </b-input-group>
            </div>
            <div class="upload-button">
              <b-button @click="validateNewDownload" class="btn btn-primary">Hochladen</b-button>
            </div>
          </div>
        </b-tab>
      </b-tabs>
      <template slot="modal-header"><h4>Download hinzufügen</h4></template>
      <template slot="modal-ok">Schließen</template>
    </b-modal>
    <b-modal id="manageCategories" size="lg" @hide="rstCatModal" ok-only>
      <b-tabs v-model="active_tabs.categories">
        <b-tab title="Kategorien" style="min-height:300px;height:100%;">
          <div class="loader-container" v-if="!ready.categories">
            <div>
              <Loader />
              <div class="loader-text">Lade Kategorien...</div>
            </div>
          </div>
          <transition
            :enter-active-class="animations.standard.enter"
            :leave-active-class="animations.standard.leave"
            :name="animations.standard.name"
          >
            <div class="table-responsive datatable-vue" v-if="ready.categories">
              <b-table
                show-empty
                :items="categories"
                @filtered="onFilteredCategories"
                :current-page="tbl_currentPage.categories"
                :filter="tbl_filter.categories"
                :per-page="tbl_perPage.categories"
                :fields="tbl_fields.categories"
              >
                <template slot="empty"><div class="text-center">Keine Kategorien hinterlegt.</div></template>
                <template v-slot:cell(created_on)="row">
                  {{ transformDate(row.item.created_on) }}
                </template>

                <template v-slot:cell(von)="row"> {{ row.item.owner.first_name }} {{ row.item.owner.last_name }} </template>
                <template v-slot:cell(actions)="row">
                  <feather :id="'remove_cat_' + row.item.id" type="trash" class="infra-blue pointer" @click="deleteCategory(row.item)"></feather>
                  <b-tooltip :target="'remove_cat_' + row.item.id" triggers="hover" placement="left">Kategorie löschen</b-tooltip>
                </template>
              </b-table>
            </div>
          </transition>
        </b-tab>
        <b-tab title="Neu">
          <div class="new-category-fields">
            <label>Bezeichnung</label>
            <div class="red inline-block" v-if="hasError('kategorie-name')">
              - mindestens {{ validation.download_kategorien.name.minlength }} Zeichen.
            </div>

            <b-input-group class="form-input-group" prepend="Abc">
              <b-form-input
                class="form-control"
                name="kategorie-name"
                v-model="newCategory.name"
                v-bind:class="{ form_error: hasError('kategorie-name') }"
              ></b-form-input>
              <feather type="check" v-if="!hasError('kategorie-name') && !updating.beschreibung" class="checkmark"></feather>
              <feather type="x" v-if="hasError('kategorie-name') && !updating.beschreibung" class="failmark"></feather>
            </b-input-group>
            <label>Beschreibung</label>
            <b-input-group class="form-input-group">
              <textarea rows="3" class="form-control" name="beschreibung" v-model="newCategory.description" />
            </b-input-group>
          </div>
          <div class="catAddButton">
            <b-button class="btn btn-primary" @click="validateNewCategory()">Hinzufügen</b-button>
          </div>
        </b-tab>
      </b-tabs>
      <template slot="modal-header"><h4>Kategorien verwalten</h4></template>
      <template slot="modal-ok">Schließen</template>
    </b-modal>
    <b-modal id="showImageModal" ok-only size="xl">
      <div class="show-image-modal-container">
        <img :src="show_image_modal.file.url" v-if="show_image_modal.file" />
      </div>
      <template slot="modal-header">
        <h4 v-if="show_image_modal.file">Preview</h4>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import vue2Dropzone from "vue2-dropzone";
import LoaderRelative from "@/components/LoaderRelative.vue";

export default {
  name: "Media",
  components: {
    dropzone: vue2Dropzone,
    Loader: LoaderRelative,
  },
  data() {
    return {
      currentKunde: false,
      tbl_fields: {
        downloads: [
          { key: "download_id.name", label: "Name", sortable: true },
          { key: "download_id.category.name", label: "Kategorie", sortable: true },
          { key: "download_id.file.type", label: "Typ", sortable: true },
          { key: "created_on", label: "Datum", sortable: true },
          { key: "uploaded_by", label: "Von", sortable: true },
          { key: "aktionen", label: "Aktionen", sortable: false },
        ],
        downloads_all: [
          { key: "name", label: "Name", sortable: true },
          { key: "category.name", label: "Kategorie", sortable: true },
          { key: "file.type", label: "Typ", sortable: true },
          { key: "created_on", label: "Datum", sortable: true },
          { key: "von", label: "Von", sortable: true },
          { key: "actions", label: "Aktionen", sortable: false },
        ],
        uploads: [
          { key: "name", label: "Name", sortable: true },
          { key: "category.name", label: "Kategorie", sortable: true },
          { key: "file.type", label: "Typ", sortable: true },
          { key: "created_on", label: "Datum", sortable: true },
          { key: "von", label: "Von", sortable: true },
          { key: "aktionen", label: "Aktionen", sortable: false },
        ],
        anfragen: [
          { key: "name", label: "Name", sortable: true },
          { key: "description", label: "Beschreibung", sortable: true },
          { key: "category", label: "Kategorie", sortable: true },
          { key: "filetype", label: "Typ", sortable: true },
          { key: "created_on", label: "Datum", sortable: true },
          { key: "von", label: "Von", sortable: true },
        ],
        categories: [
          { key: "name", label: "Kategorie", sortable: true },
          { key: "created_on", label: "Erstellt", sortable: true },
          { key: "von", label: "Von", sortable: true },
          { key: "actions", label: "Aktionen", sortable: false },
        ],
      },
      tbl_filter: {
        downloads: null,
        uploads: null,
        anfragen: null,
        downloads_all: null,
        categories: null,
      },
      tbl_perPage: {
        downloads: 10,
        uploads: 10,
        anfragen: 10,
        downloads_all: 10,
        categories: 10,
      },
      tbl_currentPage: {
        downloads: 1,
        uploads: 1,
        anfragen: 1,
        downloads_all: 1,
        categories: 1,
      },
      tbl_totalRows: {
        downloads: 1,
        uploads: 1,
        anfragen: 1,
        downloads_all: 1,
        categories: 1,
      },
      dropzone_options: {
        download: false,
        upload: false,
      },
      newCategory: {
        name: "",
        description: "",
      },
      newDownload: {
        name: "",
        description: "",
        category: "default",
        file: false,
        category_options: [],
      },
      validated: {
        newCat_name: false,
      },
      validation_errors: [],
      modal_file_details: {},
      downloads_mod: [],
      show_image_modal: {
        file: null,
      },
      active_tabs: {
        categories: 0,
        downloads_all: 0,
      },
    };
  },
  computed: {
    ...mapGetters({
      animations: "app/animations",
      api: "auth/apiSettings",
      kou: "auth/kou",
      user: "auth/user",
      toasts: "app/toasts",
      downloads: "media/downloads_kunde",
      uploads: "media/uploads_kunde",
      downloads_all: "media/downloads_all",
      categories: "media/categories",
      anfragen: "media/anfragen_kunde",
      updating: "media/updating",
      ready: "media/ready",
      isAdmin: "auth/isAdmin",
      validation: "app/validation",
      token: "auth/apiToken"
    }),
  },
  async created() {
    this.dropzone_options.download = {
      url: this.api.customUploads,
      thumbnailMethod: "contain",
      thumbnailWidth: this.dzThumbSize,
      maxFiles: 1,
      autoProcessQueue: false,
      init: function() {
        this.on("maxfilesexceeded", function(file) {
          this.removeAllFiles();
          this.addFile(file);
        });
      },
      dictDefaultMessage:
        '<svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-upload-cloud"><polyline points="16 16 12 12 8 16"></polyline><line x1="12" y1="12" x2="12" y2="21"></line><path d="M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3"></path><polyline points="16 16 12 12 8 16"></polyline></svg>',

      headers: {
        Authorization: "",
        "Cache-Control": null,
        "X-Requested-With": null,
      },
    };

    this.currentKunde = this.$route.params.kunde_id;

    try {
      await this.$store.dispatch("media/getDownloadsOfKunde", this.currentKunde);
      await this.$store.dispatch("media/getUploadsOfKunde", this.currentKunde);
      this.modDownloads();
      this.rstPagination();
    } catch (error) {
      console.log(error);
      this.$toasted.show(error, this.toasts.failure);
    }
  },
  methods: {
    async refreshDropzoneAuth() {           
      await this.$store.dispatch("auth/refreshToken");
      this.dropzone_options.download.headers.Authorization = "bearer " + this.token;
    }, 
    async deleteDownload(download) {
      try {
        await this.$store.dispatch("media/deleteDownload", download);
        await this.$store.dispatch("media/getAllDownloads");
      } catch (error) {
        console.log(error);
        this.$toasted.show(error, this.toasts.failure);
      }
    },
    async deleteCategory(cat) {
      try {
        await this.$store.dispatch("media/deleteCategory", cat.id);
        await this.$store.dispatch("media/getCategories");
      } catch (error) {
        console.log(error);
        this.$toasted.show(error, this.toasts.failure);
      }
    },
    async openImageModal(file) {
      this.show_image_modal.file = await this.$store.dispatch("images/getImgURL", {
        id: file.id,
        mode: "imgtag",
        format: "image-600-full",
        volatile: true
      });
      this.$bvModal.show("showImageModal");
    },
    rstImageModal() {
      this.show_image_modal.file = null;
    },
    isImage(type) {
      const isFile = type.indexOf("image") !== undefined ? true : false;
      return isFile;
    },
    rstCatModal() {
      this.newCategory = { name: "", description: "" };
    },
    rstPagination() {
      this.tbl_totalRows = {
        downloads: this.downloads.length + this.uploads.length,
        uploads: this.uploads.length,
        anfragen: this.anfragen.length,
        downloads_all: this.downloads_all.length,
        categories: this.categories.length,
      };
    },
    modDownloads() {
      const mod_downloads = this.downloads.map((up) => {
        return up.download_id;
      });
      this.downloads_mod = mod_downloads;
    },
    onFilteredDownloads(filteredItems) {
      this.tbl_totalRows.downloads = filteredItems.length;
      this.tbl_currentPage.downloads = 1;
    },
    onFilteredUploads(filteredItems) {
      this.tbl_totalRows.uploads = filteredItems.length;
      this.tbl_currentPage.uploads = 1;
    },
    onFilteredAnfragen(filteredItems) {
      this.tbl_totalRows.anfragen = filteredItems.length;
      this.tbl_currentPage.anfragen = 1;
    },
    onFilteredDownloadsAll(filteredItems) {
      this.tbl_totalRows.downloads_all = filteredItems.length;
      this.tbl_currentPage.downloads_all = 1;
    },
    onFilteredCategories(filteredItems) {
      this.tbl_totalRows.downloads_all = filteredItems.length;
      this.tbl_currentPage.downloads_all = 1;
    },
    async openUploadModal() {
      try {
        await this.$store.dispatch("media/getAllDownloads");
        await this.getCategories();
      } catch (error) {
        console.log(error);
        this.$toasted.show(error, this.toasts.failure);
      }

      this.$bvModal.show("addDownload");
    },
    closeUploadModal() {
      this.$bvModal.hide("addDownload");
    },
    async openCategoriesModal() {
      await this.getCategories();
      this.$bvModal.show("manageCategories");
    },
    closeCategoriesModal() {
      this.$bvModal.hide("manageCategories");
    },
    async getCategories() {
      try {
        await this.$store.dispatch("media/getCategories");
        this.getCatOptions();
      } catch (error) {
        console.log(error);
        this.$toasted.show(error, this.toasts.failure);
      }
    },
    async validateNewCategory() {
      this.validation_errors = [];
      const validationPayload = {
        context: "download_kategorien",
        field: "name",
        value: this.newCategory.name,
      };

      try {
        const response = await this.$store.dispatch("app/validateField", validationPayload);

        if (!response) this.validation_errors.push("kategorie-name");
      } catch (error) {
        console.log(error);
        this.$toasted.show("Fehler bei Feldvalidierung", this.toasts.failure);
      }

      if (this.validation_errors.length) return;
      const addCategoryPayload = {
        name: this.newCategory.name,
        description: this.newCategory.description,
      };

      try {
        await this.$store.dispatch("media/addCategory", addCategoryPayload);
        await this.$store.dispatch("media/getCategories");
        this.rstPagination();
        this.getCatOptions();
        this.rstCatModal();
        this.active_tabs.categories = 0;
      } catch (error) {
        this.$toasted.show(error, this.toasts.failure);
      }
    },
    async validateNewDownload() {
      this.validation_errors = [];
      const validationPayloadName = {
        context: "download",
        field: "name",
        value: this.newDownload.name,
      };

      try {
        const response = await this.$store.dispatch("app/validateField", validationPayloadName);
        if (!response) this.validation_errors.push("newDownload-" + validationPayloadName.field);
      } catch (error) {
        console.log(error);
        this.$toasted.show("Fehler bei Feldvalidierung", this.toasts.failure);
      }

      if (this.newDownload.category == "default") this.validation_errors.push("newDownload-category");
      if (!this.newDownload.file) this.validation_errors.push("newDownload-file");
      if (this.validation_errors.length) return;

      //if validaton success
      await this.uploadFile();
    },
    hasError(field) {
      return this.validation_errors.indexOf(field) > -1 ? true : false;
    },
    getCatOptions() {
      let categories = this.categories.map((c) => {
        return { value: c.id, text: c.name };
      });
      categories.unshift({ value: "default", text: "Bitte wählen", disabled: true });
      this.newDownload.category_options = categories;
    },
    async uploadFile() {
      await this.refreshDropzoneAuth();
      this.$refs.download_dropzone.processQueue();
    },
    async processNewDownloadFile(upload, responseDirectus) {

      const createDownloadPayload = {
        download: {
          name: this.newDownload.name,
          description: this.newDownload.description,
          file: responseDirectus.data.id,
          category: this.newDownload.category,
        },
        kunde: {
          kunde_id: this.currentKunde,
        },
      };

      try {
        await this.$store.dispatch("media/newDownload", createDownloadPayload);
        await this.$store.dispatch("media/getDownloadsOfKunde", this.currentKunde);
        await this.$store.dispatch("media/getUploadsOfKunde", this.currentKunde);
        this.modDownloads();
        this.rstPagination();
        this.active_tabs.downloads_all = 0;
      } catch (error) {
        console.log(error);
        this.$toasted.show(error, this.toasts.failure);
      }
    },
    resetUploadModal() {
      this.newDownload = {
        name: "",
        description: "",
        category: "default",
        file: false,
      };
    },
    openModalFileDetails(download) {
      this.modal_file_details = download;
      this.$bvModal.show("modal_file_details");
    },
    closeModalFileDetails() {
      this.modal_file_details = {};
      this.$bvModal.hide("modal_file_details");
    },
    async removeDownloadAssignment(download) {
      const relation = this.downloads.find((dl) => dl.download_id.id == download.id);
      try {
        await this.$store.dispatch("media/removeDownloadAssignment", relation.id);
        await this.$store.dispatch("media/getDownloadsOfKunde", this.currentKunde);
        await this.$store.dispatch("media/getUploadsOfKunde", this.currentKunde);
        this.modDownloads();
        this.rstPagination();
      } catch (error) {
        console.log(error);
        this.$toasted.show(error, this.toasts.failure);
      }
    },
    downloadFile(file) {
      this.$store.dispatch("media/downloadFile", file);
    }

  },
};
</script>

<style></style>
<style scoped>
.card .card-header {
  padding-bottom: 0px;
}

.upload-container {
  margin-top: 20px;
  position: relative;
  width: 100%;
}

.loader-container {
  display: flex;
  flex-flow: column;
  min-height: 300px;
  align-items: center;
  justify-content: center;
}

.button-container {
  display: flex;
  justify-content: flex-end;
  padding: 20px;
}

.button-container > div {
  margin: 10px;
}

.new-category-fields {
  margin-top: 10px;
  margin-bottom: 10px;
}

.checkmark,
.failmark {
  position: absolute;
  bottom: 7px;
  right: 10px;
  display: block;
  height: 20px;
  width: 20px;
}

.checkmark {
  color: green;
}

.failmark {
  color: red;
}

.form-error {
  color: red;
  font-size: 1.1em;
  margin: auto;
}

.show-image-modal-container {
  display: flex;
  flex-flow: row;
  justify-content: center;
}
</style>
